
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"currentColor","viewBox":"0 0 21 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21 22.73L1.28 3 0 4.27l5.98 6c-1.43 1.36-2.21 3.47-2.09 5.47.06.5.12 1 .29 1.5.14.6.41 1.2.71 1.73 1.08 1.73 2.95 2.97 4.96 3.22 2.14.27 4.43-.12 6.07-1.6.07-.06.12-.14.19-.21L19.73 24 21 22.73zM7.69 15.32c-.23.1-.47.04-.66-.12a.58.58 0 01-.14-.17c-1-1.29-1.26-3.07-.74-4.61l1.32 1.32c0 .93.15 1.86.49 2.75.04.1.08.2.08.33 0 .22-.15.42-.35.5zm5.7 3.45c-.28.24-.74.5-1.1.6-1.12.4-2.24-.16-2.9-.82 1.19-.28 1.9-1.16 2.11-2.05.05-.23.05-.47.03-.7l2.36 2.35c-.15.23-.31.45-.5.62z"}}),_c('path',{attrs:{"fill-rule":"evenodd","d":"M15.978 16.304L10 10.261 15.13 0v8h5l-4.152 8.304z"}})])
          )
        }
      }
    